module.exports = __webpack_public_path__ + "img/catapila.8b0e2a95.png";